import { Injectable } from '@angular/core';

import { CreateUserModel } from '../models';

@Injectable({
    providedIn: 'root'
})
export class LocalAccountCreationService implements CreateUserModel {
    private readonly languageKey = 'account.preferredLanguage';
    private readonly ageKey = 'account.age';
    private readonly firstNameKey = 'account.firstName';
    private readonly lastNameKey = 'account.lastName';
    private readonly emailOrPhoneKey = 'account.emailOrPhone';
    private readonly receivesNotificationsKey = 'account.receivesNotifications';
    private readonly agreeKey = 'account.agree';
    private readonly securityCodeKey = 'account.securityCode';

    constructor() {}

    get clientId(): number {
        return runtimeConfig.clientId;
    }

    get complete(): boolean {
        return (
            Boolean(this.preferredLanguageId) &&
            Boolean(this.ageRange) &&
            Boolean(this.firstName) &&
            Boolean(this.lastName) &&
            Boolean(this.emailOrPhoneNumber) &&
            Boolean(this.receivesNotifications) &&
            Boolean(this.acceptedPrivacyPolicy) &&
            Boolean(this.securityCode)
        );
    }

    get preferredLanguageId(): number {
        return this.get(this.languageKey) ?? Number.NaN;
    }

    set preferredLanguageId(value: number) {
        this.set(this.languageKey, value);
    }

    get ageRange(): number {
        return <any>this.get(this.ageKey);
    }

    set ageRange(value: number) {
        this.set(this.ageKey, value);
    }

    get firstName(): string {
        return this.get(this.firstNameKey) || '';
    }

    set firstName(value: string) {
        this.set(this.firstNameKey, value);
    }

    get lastName(): string {
        return this.get(this.lastNameKey) || '';
    }

    set lastName(value: string) {
        this.set(this.lastNameKey, value);
    }

    get emailOrPhoneNumber(): string {
        return this.get(this.emailOrPhoneKey) || '';
    }

    set emailOrPhoneNumber(value: string) {
        this.set(this.emailOrPhoneKey, value);
    }

    get receivesNotifications(): boolean {
        return this.get(this.receivesNotificationsKey) ?? false;
    }

    set receivesNotifications(value: boolean) {
        this.set(this.receivesNotificationsKey, value);
    }

    get acceptedPrivacyPolicy(): boolean {
        return this.get(this.agreeKey) ?? false;
    }

    set acceptedPrivacyPolicy(value: boolean) {
        this.set(this.agreeKey, value);
    }

    get securityCode(): number {
        return this.get(this.securityCodeKey) ?? Number.NaN;
    }

    set securityCode(value: number) {
        this.set(this.securityCodeKey, value);
    }

    createUserModel(): CreateUserModel {
        return {
            acceptedPrivacyPolicy: this.acceptedPrivacyPolicy,
            clientId: this.clientId,
            emailOrPhoneNumber: this.emailOrPhoneNumber,
            firstName: this.firstName,
            lastName: this.lastName,
            preferredLanguageId: this.preferredLanguageId,
            receivesNotifications: this.receivesNotifications,
            securityCode: this.securityCode
        };
    }

    clear(): void {
        [
            this.languageKey,
            this.ageKey,
            this.firstNameKey,
            this.lastNameKey,
            this.emailOrPhoneKey,
            this.receivesNotificationsKey,
            this.agreeKey,
            this.securityCodeKey
        ].forEach((key) => sessionStorage.removeItem(key));
    }

    private get<T>(key: string): T | null {
        const value = sessionStorage.getItem(key);
        return value ? <T>JSON.parse(value) : null;
    }

    private set(key: string, value: any) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }
}
